import React from "react";
import { useNavigate } from "react-router-dom";
import { closedAppImage, FileIcon } from "../../assets";
import { CodeVilleButton } from "../../components";
import styles from "./styles.module.css";

const CodeVilleClosedAppPage = () => {
  const navigate = useNavigate();

  return (
    <main className={styles.mainContainer}>
      <aside className={styles.textContent}>
        <h1>Application is closed</h1>

        <div className={styles.actionBtnWrapper}>
          <CodeVilleButton label="Go to Home" buttonType="secondary" onClick={() => navigate("/codeville")} />

          <CodeVilleButton
            label="Join the waitlist"
            icon={<FileIcon className={styles.nofillIcon} />}
            buttonType="primary"
            onClick={()=>window.open("https://docs.google.com/forms/d/e/1FAIpQLSckceP67YEE2jWtU9iBtovJbVnSXsxzyW7xb74YU2_PahqIXg/viewform?usp=preview", "_blank", "noopener,noreferrer")}
          />
        </div>
      </aside>
      <aside className={styles.imageContainer}>
        <img src={closedAppImage} alt="" />
      </aside>
    </main>
  );
};

export { CodeVilleClosedAppPage };
